import { createContext } from "react";

export const ExternalsContext = createContext({});
